export type SessionStatus = 'active' | 'inactivity-warning' | 'absolute-warning' | 'logging-out'

export interface SessionState {
  status: SessionStatus
  deadline: number | null
}

export type SessionAction =
  | { type: 'WARN_INACTIVITY'; deadline: number }
  | { type: 'WARN_ABSOLUTE'; deadline: number }
  | { type: 'STAY_ACTIVE' }
  | { type: 'LOGGING_OUT' }
  | { type: 'RESET' }

export const initialState: SessionState = { status: 'active', deadline: null }

export function sessionReducer(state: SessionState, action: SessionAction): SessionState {
  switch (action.type) {
    case 'WARN_INACTIVITY':
      if (state.status !== 'active') return state
      return { status: 'inactivity-warning', deadline: action.deadline }
    case 'WARN_ABSOLUTE':
      if (state.status === 'logging-out') return state
      return { status: 'absolute-warning', deadline: action.deadline }
    case 'STAY_ACTIVE':
      if (state.status !== 'inactivity-warning') return state
      return { status: 'active', deadline: null }
    case 'LOGGING_OUT':
      return { status: 'logging-out', deadline: null }
    case 'RESET':
      return initialState
    default:
      return state
  }
}
